/** Read-only status pill used in admin list views. */
import React from 'react';
import { FileText, Link as LinkIcon, Globe } from 'lucide-react';

const STYLES = {
  draft:        { label: 'Borrador',     icon: FileText, classes: 'text-charcoal-600 bg-gray-100 border-gray-200' },
  private_link: { label: 'Link privado', icon: LinkIcon, classes: 'text-amber-800 bg-amber-50 border-amber-200' },
  public:       { label: 'Público',      icon: Globe,    classes: 'text-emerald-800 bg-emerald-50 border-emerald-200' },
};

export default function StatusBadge({ status }) {
  const s = STYLES[status] || STYLES.draft;
  const Icon = s.icon;
  return (
    <span className={`inline-flex items-center gap-1 text-[11px] font-medium px-2 py-0.5 rounded-full border ${s.classes}`} data-testid={`status-badge-${status}`}>
      <Icon size={10} /> {s.label}
    </span>
  );
}
